import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useEffect, useState } from "react";
import { PropertyLine } from "./propertyLine";
import { SyncedSliderPropertyLine } from "./syncedSliderPropertyLine";
import { Color4 } from "core/Maths/math.color";
import { ColorPickerPopup } from "../../primitives/colorPicker";
/**
 * Reusable component which renders a color property line containing a label, colorPicker popout, and expandable RGBA values
 * The expandable RGBA values are synced sliders that allow the user to modify the color's RGBA values directly
 * @param props - PropertyLine props, replacing children with a color object so that we can properly display the color
 * @returns Component wrapping a colorPicker component with a property line
 */
const ColorPropertyLine = forwardRef((props, ref) => {
    ColorPropertyLine.displayName = "ColorPropertyLine";
    const [color, setColor] = useState(props.value);
    useEffect(() => {
        setColor(props.value);
    }, [props.value]);
    const onSliderChange = (value, key) => {
        let newColor;
        if (key === "a") {
            newColor = Color4.FromColor3(color, value);
        }
        else {
            newColor = color.clone();
            newColor[key] = value / 255;
        }
        setColor(newColor); // Create a new object to trigger re-render
        props.onChange(newColor);
    };
    const onColorPickerChange = (newColor) => {
        setColor(newColor);
        props.onChange(newColor);
    };
    return (_jsx(PropertyLine, { ref: ref, ...props, expandedContent: color ? _jsx(ColorSliders, { color: color, onSliderChange: onSliderChange }) : undefined, children: _jsx(ColorPickerPopup, { ...props, onChange: onColorPickerChange, value: color }) }));
});
const ColorSliders = ({ color, onSliderChange }) => (_jsxs(_Fragment, { children: [_jsx(SyncedSliderPropertyLine, { label: "R", value: color.r * 255, min: 0, max: 255, onChange: (value) => onSliderChange(value, "r") }), _jsx(SyncedSliderPropertyLine, { label: "G", value: color.g * 255, min: 0, max: 255, onChange: (value) => onSliderChange(value, "g") }), _jsx(SyncedSliderPropertyLine, { label: "B", value: color.b * 255, min: 0, max: 255, onChange: (value) => onSliderChange(value, "b") }), color instanceof Color4 && _jsx(SyncedSliderPropertyLine, { label: "A", value: color.a, min: 0, max: 1, step: 0.01, onChange: (value) => onSliderChange(value, "a") })] }));
export const Color3PropertyLine = ColorPropertyLine;
export const Color4PropertyLine = ColorPropertyLine;
//# sourceMappingURL=colorPropertyLine.js.map